import React from 'react';
import styles from './page-layout.module.scss';
import { Footer, CookieBanner } from 'widgets/index';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div className={`${styles.page__container} ${className || ''}`}>
      <main className={styles.page__content}>{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
};
